<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Identificação do usuário"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="form.usuario.nome"
                        disabled
                        label="Nome"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :value="form.usuario.ocupacao"
                        disabled
                        label="CBO"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Origem"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="unidadesParametrizadas"
                                label="Unidade"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.origem.unidadeId"
                                value-field="unidadeId"
                                @change="handleUnidadeChange()"
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="infraestruturas"
                                textField="nome"
                                v-model="model.origem.infraestruturaId"
                                valueField="id"
                                show-default-option
                                :disabled="!model.origem.unidadeId"
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="form.prestadores"
                                label="Prestador"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.origem.prestadorId"
                                value-field="prestadorId"
                                :disabled="!model.origem.infraestruturaId"
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="form.exames"
                                label="Grupo de exame"
                                show-default-option
                                text-field="nome"
                                v-model="model.origem.grupoId"
                                :disabled="!model.origem.prestadorId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-col>

                <rkm-col
                    class="mt-1"
                    cols="6"
                >
                    <rkm-calendar
                        :items="diasCalendario"
                        @click="handleCalendarioClick"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <ModalAcao
            :data="{form, model}"
            @cancel="$refs.ModalCancelamento.open($event)"
            @destiny="$refs.ModalDestino.open($event)"
            @reschedule="$refs.ModalReagendamento.open($event)"
            ref="ModalAcao"
        />

        <ModalCancelamento
            :data="{form, model}"
            :usuario-id="id"
            @saved="loadVagas()"
            ref="ModalCancelamento"
        />

        <ModalDestino
            :data="{form, model}"
            @reschedule="$refs.ModalReagendamento.open($event)"
            ref="ModalDestino"
        />

        <ModalReagendamento
            :data="{form, model}"
            :usuario-id="id"
            @closed="loadVagas()"
            ref="ModalReagendamento"
        />
    </div>
</template>

<script>
// Components.
import ModalAcao from './components/tipo-acao/Modal'
import ModalCancelamento from './components/cancelamento/Modal'
import ModalDestino from './components/destino/Modal'
import ModalReagendamento from './components/reagendamento/Modal'

import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'
import statusJornada from '@/enums/exame-imagem/statusJornada'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        ModalAcao,
        ModalCancelamento,
        ModalDestino,
        ModalReagendamento,
    },
    computed: {
        unidadesParametrizadas() {

            return this.form.unidadesParametrizadas
        },
        infraestruturas() {

            if (this.model.origem.unidadeId) {

                let infraestruturaPrincipal = this.form.unidadesParametrizadas.find(u => u.unidadeId === this.model.origem.unidadeId).infraestruturas

                    this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            } else {
                this.setInfraestrutura()
            }

            return []
        },
        feriados() {
            return this.form.origem.feriados.map(feriado => {
                return {
                    dates: this.others.moment(feriado.data, 'DD/MM/YYYY'),
                    highlight: 'yellow',
                    popover: feriado.observacao,
                    title: feriado.tipoDescricao,
                }
            })
        },
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                ocupacao: {required: true},
                especialidade: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            reagendamentoExame: this.getConectaSusRepository('exameImagem.reagendamentoExame'),
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
        }
    },
    data: () => ({
        form: null,
        model: null,
        others: {moment},
        diasCalendario: [],
        enums:{
            tipoControleJornada,
            statusJornada
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.model.origem.infraestruturaId = localAtendimento.id
            } else {

                this.model.origem.infraestruturaId = null
            }
        },
        setInfraestrutura() {

            this.model.origem.infraestruturaId = null
        },
        handleUnidade() {

            if (this.unidadesParametrizadas.length === 1) {

                this.model.origem.unidadeId = this.unidadesParametrizadas[0].unidadeId
            }
        },
        handlePrestador() {

            if (this.form.prestadores.length === 1) {

                this.model.origem.prestadorId = this.form.prestadores[0].prestadorId
            }
        },
        handleGrupo() {

            if (this.form.exames.length === 1) {

                this.model.origem.grupoId = this.form.exames[0].id
            }
        },
        load() {
            this.setLoading()

            this.repositories.reagendamentoExame.edit(this.id)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                    this.$emit('loaded', {form: this.form, model: this.model})
                    this.handleUnidade()
                    this.handlePrestador()
                    this.handleGrupo()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange() {
            this.form.origem.infraestruturas = []
            this.form.origem.exames = []
            this.form.origem.prestadores = []
            this.diasCalendario = []
            this.model.origem.prestadorId = null
            this.model.origem.grupoId = null
        },
        handleInfraestruturaChange() {
            this.form.origem.exames = []
            this.form.origem.prestadores = []
            this.diasCalendario = []
            this.model.origem.prestadorId = null
            this.model.origem.grupoId = null
        },
        handlePrestadorChange() {
            this.form.origem.exames = []
            this.diasCalendario = []
            this.model.origem.grupoId = null
        },
        handleCalendarioClick(value) {

            if (!this.jornadas || !this.model.origem.agendamentos) {
                return
            }

            var diaTratado = moment(value.date).format('DD/MM/YYYY')
                diaTratado = diaTratado.split("/").reverse().join("-")

            const diaSelecionado = this.jornadas.find(
                dias => dias.data.split("/").reverse().join("-") == diaTratado            )

            const existe = this.model.origem.agendamentos
                .find(agendamento => agendamento.data == moment(value.date).format('DD/MM/YYYY'))

            if (!existe && diaSelecionado) {
                this.showAlert('Não existe agendamento para a data selecionada.', 'Atenção')
                return
            }

            if (diaSelecionado) {
                this.$refs.ModalAcao.open(value.date)
            }
        },
        loadVagas() {

            this.vagas = []
            this.jornadas = []
            this.diasCalendario = []

            this.setLoading()

            this.repositories.reagendamentoExame.getJornadas({
                unidade_id: this.model.origem.unidadeId,
                infraestrutura_id: this.model.origem.infraestruturaId,
                exame_id: this.model.origem.grupoId,
                prestador_id: this.model.origem.prestadorId,
                profissional_id: this.form.usuario.id,
            })
            .then(response => {

                this.model.origem.agendamentos = response.data.agendamentos
                this.vagas = response.data.agendamentos
                this.jornadas = response.data.jornadas
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading(this.$nextTick(() => this.alterCalendar())))
        },
        alterCalendar(){

            let diasCalendario = []

            let dataAtual = this.form.dataAtual
            dataAtual = dataAtual.split("/").reverse().join("-")

            if (this.jornadas.length == 0) {

                this.showValidationNotification(`Não existe jornada cadastrada para a unidade, local de atendimento,
                prestador, grupo de exame e profissional selecionado.`)

                return false
            }

            this.jornadas.filter(u => u.profissionalId === this.form.usuario.id
                && u.exameId === this.model.origem.grupoId && u.unidadeId === this.model.origem.unidadeId)
                .map(unidade => {

                    let vagas = this.loadQuantidadeVagas(unidade)

                    if (moment(unidade.data.split("/").reverse().join("-")).isSameOrAfter(dataAtual)) {


                                if(this.getJornada(unidade) >= vagas){

                                    diasCalendario.push({
                                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                        'title': `${this.getJornada(unidade)}/${vagas}`,
                                        'highlight': 'red',
                                    })
                                } else {

                                    diasCalendario.push({
                                        'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                                        'title': `${this.getJornada(unidade)}/${vagas}`,
                                        'highlight': unidade.statusId === this.enums.statusJornada.ATIVO ? 'green' : 'gray',
                                        'popover':  unidade.statusNome
                                    })
                                }
                    } else {

                        diasCalendario.push({
                            'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                            'title': `${this.getJornada(unidade)}/${vagas}`,
                            'highlight': 'gray',
                            'fillMode': 'light',
                        })
                    }
            })

            this.form.origem.feriados.map(feriado => {

                diasCalendario.push({
                    'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                    'highlight': 'yellow',
                    'title': feriado.tipoDescricao,
                    'popover':  feriado.observacao
                })
            })

            this.diasCalendario = diasCalendario
        },
        getJornada(agendamento) {

            let vagasPreenchidas = 0

            if(agendamento.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                this.vagas.filter(item => item.data === agendamento.data)
                    .map(exameIncluido => {

                        vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                    })

                    return vagasPreenchidas

            } else {

                vagasPreenchidas = this.vagas.filter(item => item.data === agendamento.data).length;

                return vagasPreenchidas
            }
        },
        loadQuantidadeVagas(unidade) {

            let quantidade = this.jornadas.filter(item => item.data === unidade.data
                && item.profissionalId === this.form.usuario.id
                && item.exameId === this.model.origem.grupoId
                && item.unidadeId === this.model.origem.unidadeId
            )
                .reduce((sum, element) => {

                    if (element.vagas) {
                        sum = sum + Number(element.vagas);
                    }

                    return sum;
                },0)

            return quantidade
        },
        getPrestadores() {

            this.setLoading()

            this.repositories.reagendamentoExame.getPrestadores({
                infraestrutura_id: this.model.origem.infraestruturaId,
                profissional_id: this.form.usuario.id,
            })
            .then(response => {

                this.form.prestadores = response.data
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getGrupos() {

            this.setLoading()

            this.repositories.reagendamentoExame.getGrupos({
                infraestrutura_id: this.model.origem.infraestruturaId,
                profissional_id: this.form.usuario.id,
                prestador_id: this.model.origem.prestadorId,
            })
            .then(response => {

                this.form.exames = response.data
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number, required: true},
    },
    watch: {
        'model.origem.grupoId' (value) {

            this.vagas = []
            this.jornadas = []
            this.diasCalendario = []

            if (value) {
                this.loadVagas()
            }
        },
        'model.origem.infraestruturaId' (value) {

            this.handleInfraestruturaChange()

            if (value) {
                this.getPrestadores()
            }
        },
        'model.origem.prestadorId' (value) {

            this.handlePrestadorChange()

            if (value) {
                this.getGrupos()
            }
        },
    },
}
</script>